import trafluxLogoImage from "../images/TrafluxLogo.webp"
import trafluxTersLogoImage from "../images/TrafluxTersRenkLogo.webp"
import GirisYap from "../images/GirisYap.webp"
import AtlasLogoImage from "../images/Atlas Logo.webp"
import HeaderTrafficFlowImage from "../images/HeaderTrafficFlow.webp"
import WayImage from "../images/concrete-wall-texture-web.webp"
import CarImage from "../images/Araç.webp"
import TSliderResim1 from "../images/TSliderResim1.webp"
import TSliderResim2 from "../images/TSliderResim2.webp"
import TSliderResim3 from "../images/TSliderResim3.webp"
import TSliderResim4 from "../images/TSliderResim4.webp"

import TGridTrafik from "../images/TGridTrafik.webp"
import TGridBizKimiz from "../images/TGridBizKimiz.webp"
import TGridUrun from "../images/TGridUrun.webp"
import TGridReferans from "../images/TGridReferans.webp"

import TLocation from "../images/Konum.webp"
import THeaderIletisim from "../images/HeaderIletisim.webp"
import THeaderHakkimizda from "../images/HeaderHakkimizda.webp"
import TSvgShapeHeader from "../images/TSvgShapeHeader.webp"
import TSvgShape from "../images/TSvgShape.webp"
import TSvgShapeContactUs from "../images/SvgShapeContactUs.webp"

import TSecSliderVizyon from "../images/TSecSliderVizyon.webp"
import TSecSliderMisyon from "../images/TSecSliderMisyon.webp"
import TSecSliderDeger from "../images/TSecSliderDeger.webp"

import TGreenTrafficLight from "../images/GreenTrafficLight.webp"
import TYellowTrafficLight from "../images/YellowTrafficLight.webp"
import TRedTrafficLight from "../images/RedTrafficLight.webp"

import TIconBizKimiz from "../images/TIconBizKimiz.webp"
import TIconSureclerimiz from "../images/TIconSureclerimiz.webp"
import TIconReferanslar from "../images/TIconReferanslar.webp"

import TNavAuthShadow from "../images/NavAuthShadow.webp"

import THata from "../images/TErrorPage.webp"

import TWorkPOrder from "../images/TWorkPOrder.webp"
import TWorkPPlan from "../images/TWorkPPlan.webp"
import TWorkPSupply from "../images/TWorkPSupply.webp"
import TWorkPAssembly from "../images/TWorkPAssembly.webp"
import TWorkPSoftwareDevelopment from "../images/TWorkPSoftwareDevelopment.webp"
import TWorkPFinalControl from "../images/TWorkPFinalControl.webp"
import TWorkPIntegrationSupport from "../images/TWorkPIntegrationSupport.webp"
import TWorkPMaintenanceService from "../images/TWorkPMaintenanceService.webp"


export const Auth = GirisYap
export const Error = THata
export const Logo = trafluxLogoImage
export const TersLogo = trafluxTersLogoImage
export const AtlasLogo = AtlasLogoImage
export const NavIconSüreclerimiz = TIconSureclerimiz
export const NavIconBizKimiz = TIconBizKimiz
export const NavIconReferanslar = TIconReferanslar
export const NavAuthShadow = TNavAuthShadow
export const ImageSlider1 = TSliderResim1
export const ImageSlider2 = TSliderResim2
export const ImageSlider3 = TSliderResim3
export const ImageSlider4 = TSliderResim4
export const SecImageSliderModern = TSecSliderVizyon
export const SecImageSliderNature = TSecSliderMisyon
export const SecImageSliderComfort = TSecSliderDeger
export const GridProduct = TGridTrafik
export const GridDoor = TGridBizKimiz
export const GridFrame = TGridUrun
export const GridJamb = TGridReferans
export const SvgShapeHeader = TSvgShapeHeader
export const SvgShape = TSvgShape
export const SvgShapeContactUs = TSvgShapeContactUs
export const HeaderContactUs = THeaderIletisim
export const HeaderAboutUs = THeaderHakkimizda
export const HeaderTrafficFlow = HeaderTrafficFlowImage
export const Way = WayImage
export const Car = CarImage
export const Location = TLocation
export const GreenTrafficLight = TGreenTrafficLight
export const RedTrafficLight = TRedTrafficLight
export const YellowTrafficLight = TYellowTrafficLight
export const WorkOrder = TWorkPOrder
export const WorkPlan = TWorkPPlan
export const WorkSupply = TWorkPSupply
export const WorkPAssembly = TWorkPAssembly
export const WorkPSoftwareDevelopment = TWorkPSoftwareDevelopment
export const WorkPFinalControl = TWorkPFinalControl
export const WorkPIntegrationSupport = TWorkPIntegrationSupport
export const WorkPMaintenanceService = TWorkPMaintenanceService

